import instance from '@apis/instance';
import {
  CancelGiftOrderRequest,
  GiftOrderDetailResponse,
  GiftOrderRequest,
  GiftOrderResponse,
} from '@models/gift';

class GiftOrderApi {
  static createGiftOrder(request: GiftOrderRequest): Promise<GiftOrderResponse> {
    return instance.post('/gift-order', request);
  }

  static getGiftOrder(giftOrderNo: string): Promise<GiftOrderDetailResponse> {
    return instance.get(`/gift-order/${giftOrderNo}`);
  }

  static cancelOrder(request: CancelGiftOrderRequest): Promise<never> {
    return instance.post('/gift-order/cancel', request);
  }
}

export default GiftOrderApi;
